module.exports = __webpack_public_path__ + "assets/img/sy_082.f3ae610b.jpg";